import { Link } from "react-router-dom"
import { useState, useEffect } from "react"
import { useDispatch } from "react-redux"
import { format } from "date-fns"
import { putFacturado, putCobrado } from "../../redux/actions/actionPresupuesto"

export default function InformePruebaCard({id, addressEvent, name_client, dateReception, dateSend, numberDocument, 
                                            totalCoeficiente, facturado: initialFacturado, cobrado: initialCobrado, facturasAsociadas}) {

    const dispatch = useDispatch();
    const [facturado, setFacturado] = useState(initialFacturado);
    const [cobrado, setCobrado] = useState(initialCobrado);
    const [facturadoColor, setFacturadoColor] = useState(initialFacturado ? "#facc15" : "#38bdf8");
    const [cobradoColor, setCobradoColor] = useState(initialCobrado ? "#a3e635" : "#38bdf8") 

    
    useEffect(() => {
        setFacturado(initialFacturado);
        setCobrado(initialCobrado)
    }, [initialFacturado, initialCobrado]);
    
    const handleFacturado = (e) => {
        const { value } = e.target;
        console.log(value);
        if(value === "facturadoOk" && facturado === false && cobrado === false){
            setFacturadoColor("#facc15")
            dispatch(putFacturado(id, {facturadoAux:true}))
            setFacturado(true)
        } else if(value === "facturadoOk" && facturado === true && cobrado === false){
            setFacturadoColor("#38bdf8")
            dispatch(putFacturado(id, {facturadoAux:false}))
            setFacturado(false)
        }
        
    }

    

    const handleCobrado = (e) => {
        const { value } = e.target;
        console.log(value);
        if(value === "cobradoOk" && facturado === true && cobrado === false){
            setCobradoColor("#a3e635")
            dispatch(putCobrado(id, {cobradoAux:true}))
            setCobrado(true)
        } else if(value === "cobradoOk" && facturado === true && cobrado === true){
            setCobradoColor("#38bdf8")
            dispatch(putCobrado(id, {cobradoAux:false}))
            setCobrado(false)
        }
        
    }

    

    return (
        <div className="flex flex-row ">            
            <div className="flex border-b border-slate-500">
            {/* <div className="flex flex-row  bg-slate-300 hover:text-slate-400"> "flex flex-row bg-green-600 hover:text-slate-400"*/}
            <Link to={`/presupuestos/${id}`}>
            
            <div className={facturado === false && cobrado === false ? 'flex flex-row text-[11px] hover:text-[14px] pt-2  text-sky-200 hover:text-orange-400' : 
                (facturado === true && cobrado === false ? 'flex flex-row text-[11px] hover:text-[14px] pt-2 text-yellow-400' : 
                    (facturado === true && cobrado === true ? 'flex flex-row text-[11px] hover:text-[14px] pt-2 text-green-500' : 'flex flex-row text-[11px] hover:text-[14px] pt-2  text-sky-200 hover:text-orange-400')
                    
                 ) }>
                <div className='w-12'>                    
                    <p className="font-bold text-center">{numberDocument}</p>
                </div>
                <div className='pl-2 w-72'>                    
                    <p className="font-bold text-left pl-2">{name_client}</p>
                </div>
                <div className='pl-2 w-[200px]'>                    
                    <p className="font-bold text-left pl-2">{addressEvent}</p>
                </div>
                <div className='w-20'>                    
                    <p className="font-bold text-center">{dateSend ? format(new Date(dateSend), "dd/MM/yyyy") : null}</p>
                </div>
                <div className='w-20'>                    
                    <p className="font-bold text-center">{dateReception ? format(new Date(dateReception), "dd/MM/yyyy") : null}</p>
                </div>               
                <div className="w-20">
                    <p className="font-bold text-center">{totalCoeficiente}</p>
                </div>
                <div className="w-36 text-[11px]">
                    <p className="pr-2 font-bold text-right text-orange-500">{facturasAsociadas}</p>
                 </div>      
                </div>
                
            </Link>
            <div className="flex font-bold text-sky-200 text-[11px] pt-2">                           
                <div className="w-16 text-center">
                    {facturado === false ? <button value={"facturadoOk"} style={{color: facturadoColor}} onClick={handleFacturado} pointer-events='none'>Facturado</button> : 
                    <button value={"facturadoOk"} style={{color: facturadoColor}} onClick={handleFacturado} pointer-events='none'>Facturado</button>}
                </div>       
                <div className="w-16 text-center">
                {cobrado === false ? <button value={"cobradoOk"} style={{color: cobradoColor}} onClick={handleCobrado} pointer-events='none'>Cobrado</button> : 
                    <button value={"cobradoOk"} style={{color: cobradoColor}} onClick={handleCobrado} pointer-events='none'>Cobrado</button>}
                </div>
            </div> 
            </div>                
        </div>
    )
}